<template>
    <div class="mt-5">
        <information-modal title="Review Document"
            :show-modal="isShowReviewEditor"
            @dismiss="hideReviewEditor">
            <form @submit.prevent="reviewDocument">
                <fieldset>
                    <div class="mb-3">
                        <label for="reviewStatus"
                            class="form-label">Status</label>
                        <select id="reviewStatus"
                            v-model="review.status"
                            class="form-select"
                            :class="{ 'is-invalid': !!errors.status}">
                            <option :value="null">Select Status</option>
                            <option value="DR">Reject</option>
                            <option value="DA">Accept</option>
                        </select>
                        <span class="invalid-feedback"
                            role="alert"
                            v-if="errors.status">
                            {{ errors.status}}
                        </span>
                    </div>
                    <div class="mb-3">
                        <label for="reviewComment"
                            class="form-label">Comment</label>
                        <textarea type="text"
                            v-model="review.comment"
                            id="reviewComment"
                            class="form-control">
                    </textarea>
                    </div>
                </fieldset>

                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal">Cancel</button>
                    <button type="submit"
                        class="btn btn-primary">Save</button>
                </div>
            </form>
        </information-modal>
        <information-modal title="Request Document"
            :show-modal="isShowCreateEditor"
            ref="createDialog"
            @dismiss="hideCreateEditor">
            <form @submit.prevent="addDocument">

                <fieldset class="border-bottom mb-3">

                    <div class="mb-3 row">
                        <div class="col-md-3">
                            <label for="documentName"
                                class="col-form-label">Name:</label>
                        </div>
                        <div class="col-md-8">

                            <text-input v-model="item.name"
                                name="name"
                                id="documentName"
                                class="form-control"
                                :error="errors.name"></text-input>
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <div class="col-md-3">
                            <label for="documentDescription"
                                class="col-form-label">Description:</label>
                        </div>
                        <div class="col-md-8">
                            <textarea-input id="documentDescription"
                                v-model="item.description"
                                class="form-control"
                                :error="errors.description"></textarea-input>

                        </div>
                    </div>
                    <div class="mb-3 row">
                        <div class="col-md-3">
                            <label for="documentTemplate"
                                class="col-form-label">Document Template:</label>
                        </div>
                        <div class="col-md-8">
                            <select v-model="item.documentTemplateId"
                                id="documentTemplate"
                                class="form-select">
                                <option :value="null">Without Document Template</option>
                                <option v-for="item in auditDocumentTemplateStore.items"
                                    :key="item.id"
                                    :value="item.id">{{ item.name }}</option>
                            </select>
                        </div>
                    </div>

                </fieldset>
                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal">Cancel</button>
                    <button class="btn btn-primary"
                        type="submit">Save</button>
                </div>
            </form>
        </information-modal>

        <information-modal title="Upload Document"
            :show-modal="isShowUploadDocument"
            @dismiss="hideUploadDocument">
            <form @submit.prevent="uploadDocument">
                <fieldset class="border-bottom mb-3">
                    <div class="mb-3 row">
                        <div class="col-md-3">
                            <label for="uploadFile"
                                class="col-form-label">File:</label>
                        </div>
                        <div class="col-md-8">
                            <file-input v-model="uploadDocumentRequest.file"
                                name="uploadFile"
                                :error="errors.file"></file-input>

                        </div>
                    </div>

                </fieldset>
                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal">Cancel</button>
                    <button class="btn btn-primary"
                        type="submit">Save</button>
                </div>
            </form>
        </information-modal>

        <information-modal title="Delete"
            key="confirmDialog"
            ref="confirmDialog"
            :show-modal="isConfirmDialog"
            :show-footer="true"
            className="confirm"
            @dismiss="hideCreateEditor">
            Are You Sure?
            <template v-slot:footer>
                <button type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal">No</button>

                <button type="button"
                    class="btn btn-primary"
                    @click="deleteDocument">Yes</button>
            </template>
        </information-modal>
        <b-filter-modal :isShowFilterEditor="isShowFilterEditor"
            :filterOptions="auditDocumentStore.filterOptions"
            :filterableFields="auditDocumentStore.filterableFields"
            @filterChanged="applyFilters"
            @dismissModal="handleDismiss"></b-filter-modal>

        <b-table-header :value="auditDocumentStore.tableOptions"
            @optionChange="handleOptionChange"
            header-slot-class="b-header-slot w-100">
            <button @click="showFilterEditor($event)"
                type="button"
                class="btn btn-primary ml-2">
                <i class="bi bi-search pe-1"></i>
                Filter
            </button>
            &nbsp;
            <button type="button"
                v-if="canRequestDocument"
                class="btn btn-primary"
                @click.prevent="showCreateEditor">Request Document</button>
            <slot name="header.toolbar"></slot>
            <span class="ms-2 filter-description"
                v-if="hasAppliedFilters">
                {{ filtersDescription }}
            </span>
            <button v-if="hasAppliedFilters"
                class="btn-close"
                v-tooltip="'Remove all currently applied filters.'"
                @click.prevent="resetFilters()">
            </button>
            <template v-slot:pagingStart>
                <div class="float-end">
                    <div class="btn-group position-absolute"
                        style="top: -25px; margin-left: 295px;"
                        role="group">
                        <button type="button"
                            class="btn border border-secondary dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false">
                            Export
                        </button>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item"
                                    :href="`${url}/error-descriptions/download/csv`">Download as .csv</a></li>
                            <li><a class="dropdown-item"
                                    :href="`${url}/error-descriptions/download/xlsx`">Download as .xlsx</a></li>
                        </ul>
                    </div>

                </div>
            </template>
        </b-table-header>
        <b-table :items="auditDocumentStore.items"
            :columns="columns"
            :caption="''"
            :value="auditDocumentStore.tableOptions"
            @optionChange="handleOptionChange">

            <template v-slot:cell.incidentNumber="{ item, column }">
                <span>{{ item.incidentNumber }}</span>
            </template>

            <template v-slot:cell.status="{ item, column }">

                {{item.status}}
                <span v-if="item.statusCode!=='DU' && item.statusCode!=='DA'">
                    <i class="bi bi-info-circle-fill text-info"
                        v-if="item.comment"
                        v-tooltip="item.comment"></i>
                </span>

            </template>
            <template v-slot:cell.name="{ item, column }">
                {{ item.name }}
                <i class="bi bi-info-circle-fill text-info"
                    v-if="item.description"
                    v-tooltip="item.description"></i>
            </template>
            <template v-slot:cell.review="{ item, column }">

            </template>

            <template v-slot:cell.template="{ item, column }">
                <template v-if="item.documentTemplateFileId">
                    <span class="d-block">
                        {{ item.documentTemplateName }}
                        <small v-if="item.documentTemplateUpdatedOn">(Updated at {{ item.documentTemplateUpdatedOn }})</small>
                    </span>
                    <a class="btn btn-secondary btn-sm mt-2"
                        :href="`api/v1/audit/file/${item.documentTemplateFileId}`"> View Template </a>
                </template>
                <span v-else></span>
            </template>

            <template #cell.agencyAction="{ item }">

                <a v-if="item.fileId"
                    class="btn btn-secondary btn-sm me-2"
                    :href="`api/v1/audit/file/${item.fileId}`"
                    download=""> View Document</a>
                <span v-else></span>

                <span v-if="item.statusCode!=='DU' && item.statusCode!=='DA'">

                    <button type="button"
                        @click.prevent="showUploadDocument(item.id)"
                        v-if="item.statusCode=='DN'&& !runAudits"
                        class="btn btn-primary btn-sm me-2">
                        Upload Document
                    </button>

                </span>

                <button type="button"
                    @click.prevent="showUploadDocument(item.id)"
                    v-if="(item.statusCode=='DR'|| item.statusCode=='DU') && !runAudits"
                    class="btn btn-primary btn-sm me-2">
                    Replace Document
                </button>
                <span v-else></span>

                <button class="btn btn-primary btn-sm me-2"
                    v-if="runAudits && item.statusCode=='DU'"
                    @click.prevent="showReviewEditor(item.id)">
                    Provide Feedback
                </button>
                <span v-else></span>

            </template>

            <template #cell.actions="{ item }">

                <button @click="deleteDocumentConfirm(item.id)"
                    type="button"
                    v-if="canDelete"
                    class="btn btn-sm btn-danger">
                    Delete
                </button>
                <span v-else></span>

            </template>
        </b-table>
        <b-table-header :value="auditDocumentStore.tableOptions"
            @optionChange="handleOptionChange"
            header-slot-class="b-header-slot w-100">
        </b-table-header>
    </div>
</template>
<script lang="ts" setup>
import BTable from "../BTable/BTable.vue";
import BTableHeader from "../BTable/BTableHeader.vue";
import { BTableOptions, BTableColumn } from "../BTable/BTable.types";

import BFilterModal from "../BFilterEditor/BFilterModal.vue";
import InformationModal from "../Misc/InformationModal.vue";

import {
    BFilterOptions,
    describeFilters,
} from "../BFilterEditor/BFilterEditor.types";
import { computed, onMounted, reactive, ref } from "vue";

import type {
    Audit,
    AuditDocument,
    AuditReviewDocument,
    UploadDocumentRequest,
} from "@/audit.types";
import { useAuditDocumentStore } from "@/stores/auditDocumentStore";
import { mixed, number, object, string } from "yup";
import { useFormValidation } from "@/validation";

import TextInput from "../Fields/TextInput.vue";
import TextareaInput from "../Fields/TextareaInput.vue";
import FileInput from "../Fields/FileInput.vue";
import { useAuditDocumentTemplateStore } from "@/stores/auditDocumentTemplateStore";
import { debounce } from "vue-debounce";

var updateData = debounce(() => getData(), "15000ms");
const auditDocumentStore = useAuditDocumentStore();
const auditDocumentTemplateStore = useAuditDocumentTemplateStore();

const canDelete = computed(() => props.runAudits);
const canRequestDocument = computed(
    () => props.runAudits && props.audit.statusCode != "AC"
);

const props = defineProps<{
    id: number;
    audit: Audit;
    runAudits: boolean;
    createAudits: boolean;
}>();

const review = ref({} as AuditReviewDocument);

const isShowFilterEditor = ref(false);
const isShowReviewEditor = ref(false);
const isConfirmDialog = ref(false);

const selectedId = ref(0);

const deleteDocumentConfirm = async function (id) {
    isConfirmDialog.value = true;
    selectedId.value = id;
};

const hasAppliedFilters = ref(false);
const columns = reactive<BTableColumn[]>([
    {
        key: "name",
        text: "Name",
        sortable: true,
        value: (item) => item["name"],
    },
    {
        key: "template",
        text: "Template",
        sortable: true,
        value: (item) => item.description,
    },
    {
        key: "status",
        text: "Status",
        sortable: false,
        value: (item) => item["status"],
    },

    {
        key: "agencyAction",
        text: "",
        sortable: false,
        value: (item) => 2,
    },

    {
        key: "actions",
        text: "",
        sortable: false,
        class: (item) => ["text-nowrap text-end"],
        value: (item) => 2,
    },
]);

const item = ref({} as AuditDocument);
const schema = object<AuditDocument>({
    name: string().required().label("Name"),
});

const filtersDescription = computed(() => {
    if (auditDocumentStore.filterOptions == null) {
        return "";
    }
    return describeFilters(
        auditDocumentStore.filterOptions.filters,
        auditDocumentStore.filterableFields
    );
});

const { handleSubmit, errors } = useFormValidation();
const addDocument = async function () {
    if (await handleSubmit(schema, item.value)) {
        item.value.auditId = props.id;
        await auditDocumentStore.create(item.value);
        await getData();
        hideCreateEditor();
    }
};

const deleteDocument = async function () {
    await auditDocumentStore.deleteItem(selectedId.value);
    await getData();
    isConfirmDialog.value = false;
};

const isShowCreateEditor = ref(false);

const showFilterEditor = function (event: any) {
    event.preventDefault();
    isShowFilterEditor.value = true;
};

const handleDismiss = function () {
    isShowFilterEditor.value = false;
};

const hideCreateEditor = function () {
    isShowCreateEditor.value = false;
};

const showCreateEditor = function () {
    isShowCreateEditor.value = true;
    item.value = {} as AuditDocument;
    item.value.documentTemplateId = null;
};

const hideUploadDocument = function () {
    isShowUploadDocument.value = false;
};

const isShowUploadDocument = ref(false);
const showUploadDocument = function (id: number) {
    uploadDocumentRequest.value = {} as UploadDocumentRequest;
    uploadDocumentRequest.value.id = id;
    isShowUploadDocument.value = true;
};

const uploadDocumentRequest = ref<UploadDocumentRequest>(
    {} as UploadDocumentRequest
);

const uploadDocumentSchema = object<UploadDocumentRequest>({
    id: number().required(),
    file: mixed().required().label("File"),
});

const uploadDocument = async () => {
    if (await handleSubmit(uploadDocumentSchema, uploadDocumentRequest.value)) {
        await auditDocumentStore.upload(uploadDocumentRequest.value);
        await getData();
        hideUploadDocument();
    }
};

const showReviewEditor = function (id: number) {
    review.value = {} as AuditReviewDocument;
    review.value.id = id;
    review.value.status = null;
    isShowReviewEditor.value = true;
};

const hideReviewEditor = () => {
    isShowReviewEditor.value = false;
};

const reviewSchema = object<AuditReviewDocument>({
    status: string().required().label("Status"),
});
const reviewDocument = async () => {
    if (await handleSubmit(reviewSchema, review.value)) {
        await auditDocumentStore.review(review.value);
        hideReviewEditor();
        await getData();
    }
};

const handleOptionChange = async function (options: BTableOptions) {
    if (options) {
        auditDocumentStore.tableOptions = options;
    }
    await getData();
};

const resetFilters = async function () {
    if (auditDocumentStore.filterOptions != null) {
        auditDocumentStore.filterOptions.filters = [];

        await getData();
    }
    isShowFilterEditor.value = false;
    hasAppliedFilters.value = false;
};
const applyFilters = async function (newFilterOptions: BFilterOptions) {
    auditDocumentStore.filterOptions = newFilterOptions;
    isShowFilterEditor.value = false;
    hasAppliedFilters.value =
        auditDocumentStore.filterOptions.filters.length > 0;

    await getData();
};

const getData = async function () {
    await auditDocumentStore.list(props.id);
    await updateData();
};
onMounted(async () => {
    await getData();
    await auditDocumentTemplateStore.list();
});
</script>
